import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-37985348"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "main-footer"
};
var _hoisted_2 = {
  class: "container d-flex flex-row py-4 justify-content-center"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Terms");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Privacy");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Disclaimer");

export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var appName = process.env.VUE_APP_NAME;
    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_button = _resolveComponent("n-button");

      var _component_router_link = _resolveComponent("router-link");

      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_n_text, {
        depth: "3",
        class: "copyright me-3"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_unref(appName)), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'Terms'
        },
        class: "text-decoration-none me-3"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            text: ""
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'Privacy'
        },
        class: "text-decoration-none me-3"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            text: ""
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'Disclaimer'
        },
        class: "text-decoration-none"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            text: ""
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])]);
    };
  }
});